import React, {useState} from 'react';
import {get} from 'lodash';
import axios from 'axios';

import {
  _setUntil,
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import Modal from './Modal'
import DateSelector from './DateSelector';

const EditVip = ({
  vipUntil,
  userId,
}) => {
  const [vipUntilState, vipUntilStateSet] = useState(_setUntil(vipUntil))

  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  const onSubmit = (e) => {
    e.preventDefault()

    requestCallback(axios.put(`/${gon.currentProvider}/api/users/${userId}/vip`, {
      user: {
        vip_until: vipUntilState,
      },
      authenticity_token: CSRF_TOKEN,
    }))
  }

  return (
    <React.Fragment>
      <a
        className='Badge Badge--yellow'
        onClick={onToggleModal}
      >
        + EDIT VIP
      </a>

      <Modal
        isActive={modal}
        onToggleModal={onToggleModal}
        klassName='Modal--vip-until'
      >
        <form
          onSubmit={onSubmit}
        >
          <h3 className='Modal__h3'>Vip until</h3>

          <div className='EditVipModal'>
            <DateSelector
              selectedDateTime={vipUntilState}
              onChange={vipUntilStateSet}
            />

            <a
              className='Button Button--gray-light'
              onClick={onToggleModal}
            >
              Cancel
            </a>

            <button
              className='Button Button--blue'
              ref={$submitButton}
            >
              Update
            </button>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
}

export default EditVip;
